import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://luxeaesthetiquecoiffure.com';
const SITE_NAME = 'Luxéa Esthétique & Coiffure YT';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_luxea-elegance/artifacts/o2s2v5ov_5fbc0e85-9c80-4e43-9dd4-de76fbca678b.png';

/**
 * Per-page SEO tags: title, description, canonical, Open Graph, Twitter,
 * plus optional BreadcrumbList JSON-LD.
 *
 * Never invent business data; only render what is passed in.
 */
const SEO = ({
  title,
  description,
  path = '/',
  keywords,
  image = DEFAULT_IMAGE,
  breadcrumbs, // [{ name, url }]
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_CA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {breadcrumbs && breadcrumbs.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs.map((b, i) => ({
              '@type': 'ListItem',
              position: i + 1,
              name: b.name,
              item: `${SITE_URL}${b.url}`,
            })),
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
